import { User } from './user';
import { BeneficiaryDetails, BankAccountDetails } from '../sendmoney/sendmoney';
export class UserProfileTMNIovation {
  userProfile: User = new User();
  beneficiaryDetails?: BeneficiaryDetails = new BeneficiaryDetails();
  bankAccountDetails?: BankAccountDetails = new BankAccountDetails();
  deviceProfile: DeviceProfile = new DeviceProfile();
  eventType: string;
  transactionAmount = 0.0;
  transactionCurrency = '';
  transactionId = 0;
}
class DeviceProfile {
  SessionID: string;
  IovationBlackBoxKey: string;
}
export enum enumEventype {
  Login,
  Device_Profile,
  Payment,
  RePayment,
  Edit_Profile,
  AddBank,
  Ragistration,
  Manage_Beneficiary,
  Change_Password,
  SecureLogin
}



// WEBPACK FOOTER //
// ./src/app/models/user/user.tm.profile.model.ts